import React from 'react';

import chaosLogo from '../../assets/img/chaos-logo.svg';
import enscapeIcon from '../../assets/img/enscape-icon.svg';
import phoenixIcon from '../../assets/img/phoenix-icon.svg';
import vantageIcon from '../../assets/img/vantage-icon.svg';
import playerIcon from '../../assets/img/player-icon.svg';
import cylindoIcon from '../../assets/img/cylindo-icon.svg';
import cloudIcon from '../../assets/img/cloud-icon.svg';
import vrayIcon from '../../assets/img/vray-icon.svg';
import cosmosIcon from '../../assets/img/cosmos-icon.svg';
import scansIcon from '../../assets/img/scans-icon.svg';
import coronaIcon from '../../assets/img/corona-icon.svg';
import instagramIcon from '../../assets/img/Instagram.svg';
import facebookIcon from '../../assets/img/Facebook.svg';
import linkedinIcon from '../../assets/img/Linkedin.svg';
import youtubeIcon from '../../assets/img/Youtube.svg';
import twitterIcon from '../../assets/img/Twitter.svg';

export const Footer = () => (
  <>
    <div className='main-footer'>
      <div className='chaos-logo'>
        <a href='https://enscape3d.com' target='_blank' rel='noreferrer'>
          <img alt='Chaos Enscape logo' src={chaosLogo} />
        </a>
      </div>
      <div className='products-logos'>
        <a href='https://enscape3d.com' target='_blank' rel='noreferrer'>
          <img alt='Chaos Enscape' src={enscapeIcon} />
        </a>
        <a href='https://www.chaos.com/fluid-dynamics-software' target='_blank' rel='noreferrer'>
          <img alt='Chaos Phoenix' src={phoenixIcon} />
        </a>
        <a href='https://www.chaos.com/vantage' target='_blank' rel='noreferrer'>
          <img alt='Chaos Vantage' src={vantageIcon} />
        </a>
        <a href='https://www.chaos.com/player' target='_blank' rel='noreferrer'>
          <img alt='Chaos Player' src={playerIcon} />
        </a>
        <a href='https://www.cylindo.com' target='_blank' rel='noreferrer'>
          <img alt='Chaos Cylindo' src={cylindoIcon} />
        </a>
        <a href='https://www.chaos.com/cloud-rendering' target='_blank' rel='noreferrer'>
          <img alt='Chaos Cloud' src={cloudIcon} />
        </a>
        <a href='https://www.chaos.com/3d-rendering-software' target='_blank' rel='noreferrer'>
          <img alt='Chaos V-Ray' src={vrayIcon} />
        </a>
        <a href='https://www.chaos.com/cosmos' target='_blank' rel='noreferrer'>
          <img alt='Chaos Cosmos' src={cosmosIcon} />
        </a>
        <a href='https://www.chaos.com/scans' target='_blank' rel='noreferrer'>
          <img alt='Chaos Scans' src={scansIcon} />
        </a>
        <a href='https://corona-renderer.com' target='_blank' rel='noreferrer'>
          <img alt='Chaos Corona' src={coronaIcon} />
        </a>
      </div>
    </div>
    <div className='sub-footer'>
      <div className='copyright'>Copyright © All rights reserved - Enscape™ 2024</div>
      <div className='terms'>
        <a
          href='https://support.enscape3d.com/hc/en-us'
          className='link'
          target='_self'
          rel='follow'
        >
          Support
        </a>
        <a
          href='https://static.chaos.com/documents/assets/000/000/393/original/EULA.pdf?1682928766'
          className='link'
          target='_self'
          rel='follow'
        >
          Terms of Use
        </a>
        <a href='https://enscape3d.com/contact-us' className='link' target='_self' rel='follow'>
          Contact
        </a>
        <a href='https://enscape3d.com/privacy' className='link' target='_self' rel='follow'>
          Privacy Policy
        </a>
      </div>
      <div className='socials'>
        <a href='https://www.instagram.com/enscape3d/' target='_blank' rel='noreferrer'>
          <img src={instagramIcon} alt='Visit our Instagram' />
        </a>
        <a href='https://www.facebook.com/Enscape3D' target='_blank' rel='noreferrer'>
          <img src={facebookIcon} alt='Visit our Facebook' />
        </a>
        <a href='https://linkedin.com/company/enscapegmbh' target='_blank' rel='noreferrer'>
          <img src={linkedinIcon} alt='Visit our LinkedIn' />
        </a>
        <a href='https://www.youtube.com/Enscape3D' target='_blank' rel='noreferrer'>
          <img src={youtubeIcon} alt='Visit our YouTube' />
        </a>
        <a href='https://twitter.com/enscape3d' target='_blank' rel='noreferrer'>
          <img src={twitterIcon} alt='Visit our Twitter' />
        </a>
      </div>
    </div>
  </>
);
